import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="mt-32 mb-10 w-[90%] md:w-[50rem] mx-auto text-lg">
      <h1 className="subscription-font text-4xl font-medium text-[#262544] text-center mb-10">
        Privacy Policy
      </h1>

      <div className="text-lg">
        Deepnap Softech ("we," "our," or "us") is committed to protecting the
        privacy of your personal information. This Privacy Policy explains how
        we collect, use, disclose, and safeguard your information when you use
        our CRM service.
      </div>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        1. Information We Collect
      </h2>
      <p className="text-lg">We collect various types of information from you, including:</p>

      <h3 className="text-xl font-bold text-[#262544] mt-2">1.1 Personal Information</h3>
      <p>
        When you register for our CRM service, we may collect personally
        identifiable information, such as:
      </p>
      <ul className="list-disc pl-5">
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Company name</li>
        <li>Payment details</li>
      </ul>

      <h3 className="text-xl font-bold text-[#262544] mt-1">1.2 Usage Data</h3>
      <p>
        We collect information on how the service is accessed and used. This
        data may include:
      </p>
      <ul className="list-disc pl-5">
        <li>IP address</li>
        <li>Browser type</li>
        <li>Pages visited</li>
        <li>Time spent on pages</li>
        <li>Device information</li>
      </ul>

      <h3 className="text-xl font-bold text-[#262544] mt-1">1.3 Data Entered into CRM</h3>
      <p>
        You own the data you input into our CRM. This data may include customer
        details, lead information, communications, and other business-related
        information.
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        2. How We Use Your Information
      </h2>
      <p>
        We use your information to provide and improve our services. Specific
        uses include:
      </p>
      <ul className="list-disc pl-5">
        <li>
          <strong>Service Delivery:</strong> To manage your account, provide
          access to CRM functionalities, and offer customer support.
        </li>
        <li>
          <strong>Billing and Payments:</strong> To process payments and manage
          subscriptions.
        </li>
        <li>
          <strong>Communication:</strong> To send you service updates,
          newsletters, and promotional offers (if you have opted in).
        </li>
        <li>
          <strong>Usage Analytics:</strong> To analyze usage patterns, improve
          service performance, and customize your experience.
        </li>
      </ul>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        3. Data Sharing and Disclosure
      </h2>
      <p>
        We do not sell, trade, or rent your personal information to third
        parties. However, we may share your information in the following
        circumstances:
      </p>

      <h3 className="text-xl font-bold text-[#262544] mt-1">3.1 Service Providers</h3>
      <p>
        We may share your information with trusted third-party service providers
        (e.g., payment processors, cloud storage) to assist us in delivering our
        CRM service.
      </p>

      <h3 className="text-xl font-bold text-[#262544] mt-1">3.2 Legal Requirements</h3>
      <p>
        We may disclose your personal information if required by law or if we
        believe it is necessary to:
      </p>
      <ul className="list-disc pl-5">
        <li>Comply with legal obligations</li>
        <li>Protect and defend the rights or property of Deepnap Softech</li>
        <li>Prevent illegal activity</li>
      </ul>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        4. Data Security
      </h2>
      <p>
        We take appropriate measures to protect your personal information from
        unauthorized access, alteration, disclosure, or destruction. These
        measures include:
      </p>
      <ul className="list-disc pl-5">
        <li>Secure servers and encryption for sensitive information</li>
        <li>Regular monitoring of our systems for vulnerabilities</li>
      </ul>
      <p>
        While we strive to use commercially acceptable means to protect your
        data, no method of transmission over the internet is 100% secure, and we
        cannot guarantee absolute security.
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        5. Data Retention
      </h2>
      <p>
        We retain your personal information for as long as your account is
        active or as needed to provide you with services. We may retain and use
        your information as necessary to comply with legal obligations, resolve
        disputes, and enforce our agreements.
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        6. Your Data Rights
      </h2>
      <p>You have the right to:</p>
      <ul className="list-disc pl-5">
        <li>Access, update, or delete your personal information at any time</li>
        <li>Object to the processing of your personal data</li>
        <li>Request the portability of your data</li>
        <li>
          Withdraw consent to the collection or use of your information (where
          consent is required)
        </li>
      </ul>
      <p>
        If you wish to exercise these rights, please contact us at{" "}
        <a href="mailto:support@deepnapsoftech.com">
          support@deepnapsoftech.com
        </a>
        .
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">7. Cookies</h2>
      <p>
        We use cookies and similar tracking technologies to enhance your
        experience, analyze website traffic, and provide personalized services.
        You can control the use of cookies through your browser settings.
        However, disabling cookies may affect your ability to use some features
        of our CRM service.
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        8. Third-Party Links
      </h2>
      <p>
        Our service may contain links to third-party websites. We are not
        responsible for the privacy practices or content of these external
        sites. We encourage you to read their privacy policies before providing
        any personal information.
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        9. Children’s Privacy
      </h2>
      <p>
        Our CRM service is not directed at individuals under the age of 18, and
        we do not knowingly collect personal information from children. If we
        become aware that we have collected personal information from a child
        without parental consent, we will take steps to remove that information.
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">
        10. Changes to This Privacy Policy
      </h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page, and the date of the latest revision will be updated
        at the top of the policy. We encourage you to review this policy
        periodically for any changes.
      </p>

      <h2 className="text-2xl font-bold text-[#262544] mt-4">11. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us
        at{" "}
        <a href="mailto:deepnapsoftech@gmail.com">deepnapsoftech@gmail.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
